import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
// import { ReactComponent as CLOSE } from '../../../../assets/images/teamclose.svg';
import { ReactComponent as CLOSE } from "../../../../assets/images/TicketImages/cancel.svg";
import { DeleteCoUserFromGroupApi } from '../../../../store/features/deleteCoUserFromGroup';

function GeneralSale(props) {
  const chracterPosition = (alphabet) => {
    const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };
  const colorCodesForAvatar = [
    '#405261', // A
    '#FF4D4F', // B
    '#FA541C', // C
    '#FA8C16', // D
    '#FAAD14', // E
    '#EB2F96', // F
    '#FADB14', // G
    '#A0D911', // H
    '#52C41A', // I
    '#5CDBD3', // J
    '#9254DE', // K
    '#F759AB', // L
    '#2F54EB', // M
    '#722ED1', // N
    '#1890FF', // O
    '#13C2C2', // P
    '#2DB7F5', // Q
    '#19BE6B', // R
    '#30A745', // S
    '#FA8C16', // T
    '#FAAD14', // U
    '#9254DE', // V
    '#F759AB', // W
    '#13C2C2', // X
    '#722ED1', // Y
    '#2DB7F5', // Z
  ];
  function getRandomColor() {
    const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    return randomColor;
  }
  const [listData, setListData] = useState([]);
  const dispatch = useDispatch();
  const { userId } = props;
  const { addGroupGeneral, addNewGrouptoUser, setAddGroupGeneral } = props;

  const DeleteCoUserFromGroup = async (IdGroup) => {
    try {
      const data = await dispatch(
        DeleteCoUserFromGroupApi({
          requestHeaders: {
            agent_id: userId,
            group_id: IdGroup,
          },
        }),
      );
      if (data.payload && data.payload.status === 200) {
        toast.success(data.payload.message);
        setAddGroupGeneral((prevGroups) => prevGroups.filter((group) => group._id !== IdGroup && group.id !== IdGroup));
      } else if (data.payload.status === 400) {
        toast.error(data.payload.message);
      } else if (data.payload.status === 404) {
        toast.error(data.payload.message);
      } else {
        toast.error('Some Error Occurred. Please try again later.');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again later.');
    }
  };



  const uniqueGroupGeneral = addGroupGeneral.filter((item, index, self) => {
    const uniqueID = item._id || item.id;
    return index === self.findIndex((t) => (t._id || t.id) === uniqueID);
  });

  // console.log('uniqueGroupGeneral', uniqueGroupGeneral);

  return (
    <div className="GeneralSale-Main-Container">
      {uniqueGroupGeneral.map((item) => (
        <div className="General-Sale-Container" key={item._id || item.id}>
          <Avatar
            sx={{
              width: '34px',
              height: '34px',
              bgcolor:
                colorCodesForAvatar[
                chracterPosition(
                  item.title.substring(0, 1).toUpperCase(),
                )
                ],
            }}
          >
            {item.title.substring(0, 1).toUpperCase()}
          </Avatar>
          <p className="spaced">{item.title}</p>
          {item.title.toLowerCase() !== 'general' && (
            <p className="item-general-close" onClick={() => DeleteCoUserFromGroup(item.id || item._id)}><CLOSE /></p>
          )}
        </div>
      ))}
    </div>
  );
}

export default GeneralSale;
